import React from 'react';
import { makeStyles,createStyles } from '@material-ui/core/styles';
import '../../assets/css/main.css';
import theme from '../../styles/theme.js';

const TermsAndConditions = (props) => {
  const classes = useStyles();
  const date = new Date(1762993697000);

return (
    <div>
      <div className='terms-container'>
        <div className='NavBar-area' />
        <div className='container'>
            <>
              <div className={classes.container}>
                <text className={classes.title}> Términos y Condiciones </text>
                <p className={classes.subTitle}>
                  Fecha de actualización: {date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  })}
                </p>
                <iframe
                title="Términos y Condiciones" 
                src='/documents/termsAndConditions.pdf#toolbar=0' width="100%" height="100vh" style={{height: '100vh'}}/>
              </div>
            </>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;

const rem = 16;

const useStyles = makeStyles({
  defaultText: {
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: 500,
  },
  container: {
    backgroundColor: theme.palette.white.main,
    width: 'calc(80%)',
    padding: '5%',
    borderRadius: 20,
    marginBottom: '5%',
    marginTop: '2%',
  },
  title: {
    // width: '60%',
      fontSize: 2.25 * rem,
    textAlign: 'center',
    fontWeight: 900,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      textAlign: 'center'
    },
  },
  subTitle: {
    fontSize: 1.25 * rem,
    fontWeight: 700,
    textAlign: 'right',
    marginBottom: '2%',
  },
  link: {
    color: theme.palette.primary.main,
    ':visited': {
      color: 'pink',
    },
  },
});